import styled from "styled-components";

import { theme } from "theme/theme";

export const EditorWrapper = styled.div`
  .text-editor {
    .ql-toolbar.ql-snow {
      border-radius: 8px 8px 0px 0px;
      padding: 15px 24px;
      border: 1px solid #f2f2f2;
      /* border-bottom: none; */
      display: flex;
      justify-content: space-between;
      height: 56px;
      .ql-formats {
        margin-right: 0px;
        button {
          width: max-content;
        }
      }
      .ql-formats:nth-child(2) {
        margin-left: auto;
      }
    }
  }
  .quill {
    .ql-container.ql-snow {
      border: 1px solid #f2f2f2;
      border-radius: 0px 0px 8px 8px;
      .ql-editor {
        font-family: "Roboto", "Noto Sans JP", sans-serif;
        padding: 64px;
        font-size: 1rem;
        line-height: 1.5;
        /* line-height: 30px; */
        height: 631px;
        overflow-y: auto;
        resize: vertical;
        h1 {
          line-height: 36px;
        }
        h2 {
          line-height: 34px;
        }
        h3 {
          line-height: 32px;
        }
        h1,
        h2,
        h3,
        h4,
        h5 {
          /* margin: 0;
          font-size: 1rem;
          letter-spacing: 0.15em; */
          font-weight: 700;
          /* margin-bottom: 1em; */
        }

        h1 {
          font-weight: 900;
        }

        strong {
          font-weight: 700 !important;
        }
        ol,
        ul {
          padding-left: 22px;
          li {
            padding-left: 0px;
          }
        }
        &::-webkit-scrollbar {
          width: 16px;
        }
        &::-webkit-scrollbar-track {
          margin: 16px 0px 13px;
          border-left: 4px solid ${theme.colors.white};
          border-right: 4px solid ${theme.colors.white};
          background: ${theme.colors.background};
          border-radius: 7px;
        }
        &::-webkit-scrollbar-thumb {
          background: #bdbdbd;
          border-radius: 7px;
          border-left: 4px solid ${theme.colors.white};
          border-right: 4px solid ${theme.colors.white};
        }
      }
      .ql-editor.ql-blank {
        &:before {
          left: 65px;
        }
      }
    }
  }
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]:before,
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]:before {
    content: "Heading 1" !important;
  }
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]:before,
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]:before {
    content: "Heading 2" !important;
  }
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]:before,
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]:before {
    content: "Heading 3" !important;
  }
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]:before,
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]:before {
    content: "Heading 4" !important;
  }
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]:before,
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]:before {
    content: "Heading 5" !important;
  }
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]:before,
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]:before {
    content: "Heading 6" !important;
  }
  .ql-snow .ql-picker.ql-header .ql-picker-item:last-child:before,
  .ql-snow .ql-picker.ql-header .ql-picker-label:last-child:before {
    content: "一般";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: "一般";
    /* font-size: 20px !important; */
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="8px"]::before {
    content: "8px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="9px"]::before {
    content: "9px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="10px"]::before {
    content: "10px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="11px"]::before {
    content: "11px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="12px"]::before {
    content: "12px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="13px"]::before {
    content: "13px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
    content: "14px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="15px"]::before {
    content: "15px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
    content: "16px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
    content: "18px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="20px"]::before {
    content: "20px";
    /* font-size: 20px !important; */
  }

  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="24px"]::before {
    content: "24px";
    /* font-size: 24px !important; */
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="28px"]::before {
    content: "28px";
    /* font-size: 28px !important; */
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="32px"]::before {
    content: "32px";
    /* font-size: 32px !important; */
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="36px"]::before {
    content: "36px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="40px"]::before {
    content: "40px";
    /* font-size: 40px !important; */
  }
  .ql-picker-label::before,
  .ql-picker-label.ql-active::before {
    content: "一般" !important;
  }
  .ql-picker-label[data-value="8px"]::before,
  .ql-picker-label.ql-active[data-value="8px"]::before {
    content: "8px" !important;
  }
  .ql-picker-label[data-value="9px"]::before,
  .ql-picker-label.ql-active[data-value="9px"]::before {
    content: "9px" !important;
  }
  .ql-picker-label[data-value="10px"]::before,
  .ql-picker-label.ql-active[data-value="10px"]::before {
    content: "10px" !important;
  }
  .ql-picker-label[data-value="11px"]::before,
  .ql-picker-label.ql-active[data-value="11px"]::before {
    content: "11px" !important;
  }
  .ql-picker-label[data-value="12px"]::before,
  .ql-picker-label.ql-active[data-value="12px"]::before {
    content: "12px" !important;
  }
  .ql-picker-label[data-value="13px"]::before,
  .ql-picker-label.ql-active[data-value="13px"]::before {
    content: "13px" !important;
  }
  .ql-picker-label[data-value="14px"]::before,
  .ql-picker-label.ql-active[data-value="14px"]::before {
    content: "14px" !important;
  }
  .ql-picker-label[data-value="15px"]::before,
  .ql-picker-label.ql-active[data-value="15px"]::before {
    content: "15px" !important;
  }
  .ql-picker-label[data-value="16px"]::before,
  .ql-picker-label.ql-active[data-value="16px"]::before {
    content: "16px" !important;
  }
  .ql-picker-label[data-value="18px"]::before,
  .ql-picker-label.ql-active[data-value="18px"]::before {
    content: "18px" !important;
  }
  .ql-picker-label[data-value="20px"]::before,
  .ql-picker-label.ql-active[data-value="20px"]::before {
    content: "20px" !important;
  }
  .ql-picker-label[data-value="24px"]::before,
  .ql-picker-label.ql-active[data-value="24px"]::before {
    content: "24px" !important;
  }
  .ql-picker-label[data-value="28px"]::before,
  .ql-picker-label.ql-active[data-value="28px"]::before {
    content: "28px" !important;
  }
  .ql-picker-label[data-value="32px"]::before,
  .ql-picker-label.ql-active[data-value="32px"]::before {
    content: "32px" !important;
  }
  .ql-picker-label[data-value="36px"]::before,
  .ql-picker-label.ql-active[data-value="36px"]::before {
    content: "36px" !important;
  }
  .ql-picker-label[data-value="40px"]::before,
  .ql-picker-label.ql-active[data-value="40px"]::before {
    content: "40px" !important;
  }
`;
